import axios from "axios";
import { APIURL, BASE_URL } from "./misc";
import { toast } from "react-toastify";

// Function to get the refresh token from storage
const getRefreshToken = () => {
  return localStorage.getItem("REFRESH_TOKEN");
};

// Function to set new access and refresh tokens
const setTokens = (accessToken, refreshToken) => {
  localStorage.setItem("HOST_TOKEN", accessToken);
  localStorage.setItem("REFRESH_TOKEN", refreshToken);
};

// Axios instance
const api = axios.create({
  baseURL: APIURL, // Replace with your backend URL
  headers: {
    "Content-Type": "application/json",
  },
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

// Interceptor to attach the access token to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("HOST_TOKEN");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle 401 and refresh token
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            return api(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshToken = getRefreshToken();

        if (!refreshToken) {
          throw new Error("No refresh token available");
        }

        const response = await axios.post(`${BASE_URL}auth/token`, {
          refresh_token: refreshToken,
          grant_type: "refresh_token",
          client_id: "R4SLSJiCfhdjChX9P62rEJe56xI8Qd3TtsEFS8g1",
          client_secret:
            "IsyUac4F5F7dFSOYnbDrSlBUr7j1Krh0je1xkKdkauVTlMkGG3hxlMN6dlNZaAXYE9hCaeBtf8Gg794jQ4t8hzgRetQBPLpsEaZnRw1VTnlKR4bg87qZGA27YUh9JFib",
        });

        const { access_token, refresh_token } = response.data;

        setTokens(access_token, refresh_token);

        api.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
        originalRequest.headers["Authorization"] = `Bearer ${access_token}`;

        processQueue(null, access_token);

        return api(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);

        localStorage.clear();
        toast.error("Session expired. Please log in again.");
        window.location.href = "/login/:user";

        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;
